import { Pipe, PipeTransform } from '@angular/core';

const domParser = new DOMParser();

@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const doc = domParser.parseFromString(value, 'text/html');
    return doc.body.textContent || '';
  }
}

export class StripHtmlPipeUtility {
  static transform(value: string): string {
    return StripHtmlPipe.prototype.transform(value);
  }
}
